import { FutureEntriesIndicatorTranslations } from "./future-entries-indicator-pt-br";

export const FUTURE_ENTRIES_INDICATOR_FR_FR: FutureEntriesIndicatorTranslations = {
	futureEntries: "Transactions futures des prochains",
	days: "{{count}} jours",
	viewFutureEntries: "Voir les Transactions Futures",
	futureEntriesTooltip:
		"Montants attendus, tels que les créances et les charges qui sont dues prochainement ou qui sont en attente en raison de fonds insuffisants.",
};
